import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyStocks } from 'app/entities/pharmacy-stock/pharmacy-stock.reducer';
import { getEntities as getPharmacyBillItems } from 'app/entities/pharmacy-bill-item/pharmacy-bill-item.reducer';
import { getEntities as getPharmacyRefundBills } from 'app/entities/pharmacy-refund-bill/pharmacy-refund-bill.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { getEntities as getPharmacyReturnBillItems } from 'app/entities/pharmacy-return-bill-item/pharmacy-return-bill-item.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-refund-bill-item.reducer';

export const PharmacyRefundBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyStocks = useAppSelector(state => state.pharmacyStock.entities);
  const pharmacyBillItems = useAppSelector(state => state.pharmacyBillItem.entities);
  const pharmacyRefundBills = useAppSelector(state => state.pharmacyRefundBill.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const pharmacyReturnBillItems = useAppSelector(state => state.pharmacyReturnBillItem.entities);
  const pharmacyRefundBillItemEntity = useAppSelector(state => state.pharmacyRefundBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyRefundBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyRefundBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyRefundBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-refund-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyStocks({}));
    dispatch(getPharmacyBillItems({}));
    dispatch(getPharmacyRefundBills({}));
    dispatch(getPharmacyBills({}));
    dispatch(getPharmacyReturnBills({}));
    dispatch(getPharmacyReturnBillItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.refundPaid !== undefined && typeof values.refundPaid !== 'number') {
      values.refundPaid = Number(values.refundPaid);
    }
    if (values.refundQty !== undefined && typeof values.refundQty !== 'number') {
      values.refundQty = Number(values.refundQty);
    }
    if (values.soldQty !== undefined && typeof values.soldQty !== 'number') {
      values.soldQty = Number(values.soldQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }

    const entity = {
      ...pharmacyRefundBillItemEntity,
      ...values,
      pharmacyStock: pharmacyStocks.find(it => it.id.toString() === values.pharmacyStock?.toString()),
      saleBillItem: pharmacyBillItems.find(it => it.id.toString() === values.saleBillItem?.toString()),
      refundBill: pharmacyRefundBills.find(it => it.id.toString() === values.refundBill?.toString()),
      saleBill: pharmacyBills.find(it => it.id.toString() === values.saleBill?.toString()),
      returnBill: pharmacyReturnBills.find(it => it.id.toString() === values.returnBill?.toString()),
      returnItem: pharmacyReturnBillItems.find(it => it.id.toString() === values.returnItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyRefundBillItemEntity,
          pharmacyStock: pharmacyRefundBillItemEntity?.pharmacyStock?.id,
          saleBillItem: pharmacyRefundBillItemEntity?.saleBillItem?.id,
          refundBill: pharmacyRefundBillItemEntity?.refundBill?.id,
          saleBill: pharmacyRefundBillItemEntity?.saleBill?.id,
          returnBill: pharmacyRefundBillItemEntity?.returnBill?.id,
          returnItem: pharmacyRefundBillItemEntity?.returnItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyRefundBillItem.home.createOrEditLabel" data-cy="PharmacyRefundBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.home.createOrEditLabel">
              Create or edit a PharmacyRefundBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-refund-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyRefundBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.chargedMrp')}
                id="pharmacy-refund-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.refundPaid')}
                id="pharmacy-refund-bill-item-refundPaid"
                name="refundPaid"
                data-cy="refundPaid"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.refundQty')}
                id="pharmacy-refund-bill-item-refundQty"
                name="refundQty"
                data-cy="refundQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.soldQty')}
                id="pharmacy-refund-bill-item-soldQty"
                name="soldQty"
                data-cy="soldQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.manufacDate')}
                id="pharmacy-refund-bill-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.expDate')}
                id="pharmacy-refund-bill-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.active')}
                id="pharmacy-refund-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.cursor')}
                id="pharmacy-refund-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.timestampentry')}
                id="pharmacy-refund-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.microSec')}
                id="pharmacy-refund-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.lastupdated')}
                id="pharmacy-refund-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-refund-bill-item-pharmacyStock"
                name="pharmacyStock"
                data-cy="pharmacyStock"
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.pharmacyStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStocks
                  ? pharmacyStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-item-saleBillItem"
                name="saleBillItem"
                data-cy="saleBillItem"
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.saleBillItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBillItems
                  ? pharmacyBillItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-item-refundBill"
                name="refundBill"
                data-cy="refundBill"
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.refundBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyRefundBills
                  ? pharmacyRefundBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-item-saleBill"
                name="saleBill"
                data-cy="saleBill"
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.saleBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-item-returnBill"
                name="returnBill"
                data-cy="returnBill"
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.returnBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-item-returnItem"
                name="returnItem"
                data-cy="returnItem"
                label={translate('tinyMedicRestApp.pharmacyRefundBillItem.returnItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBillItems
                  ? pharmacyReturnBillItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-refund-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyRefundBillItemUpdate;
